"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _flex = require("@mui-treasury/components/flex");

var _customProps = require("../../../../utils/customProps");

var _customComponents = require("../../../../utils/customComponents");

/* eslint-disable max-len */

/* istanbul ignore next */
var MusicListItem = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/MusicListItem/MusicListItem'));
  });
});
/* istanbul ignore next */

var ChatzListItem = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/ChatzListItem/ChatzListItem'));
  });
});
/* istanbul ignore next */

var TrendyListItem = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/TrendyListItem/TrendyListItem'));
  });
});
var components = {
  MusicListItem: MusicListItem,
  ChatzListItem: ChatzListItem,
  TrendyListItem: TrendyListItem
};

var StyledList = function StyledList(_ref) {
  var width = _ref.width,
      content = _ref.content,
      storyblokClass = _ref.storyblokClass,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid;
  return /*#__PURE__*/_react.default.createElement(_flex.Column, {
    gap: 2,
    width: width,
    className: storyblokClass,
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, content.map(function (component, key) {
    return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, (0, _customComponents.renderComponentsWithBridge)(components, component, key));
  }));
};

var _default = StyledList;
exports.default = _default;
StyledList.propTypes = {
  /** width of list */
  width: _propTypes.default.string,

  /** MuiListItem */
  content: function content(props, propName, componentName) {
    var comps = ['ListItem'];
    return (0, _customProps.validComponents)(props, propName, componentName, comps);
  },

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
StyledList.defaultProps = {
  width: '100%',
  content: [],
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};